import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './text.magic.css.js';
import script from './text.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.unsafeContent)?_c(_vm.tag || 'div',_vm._b({tag:"component",staticClass:"text",class:{
        'text--content': _vm.contentText,
        'text--offer': _vm.offerText,
        'text--promotion': _vm.promotionText,
        'text--landing': _vm.landingPageText,
        'text--carousel': _vm.carouselText,
        'text--carousel-enhanced': _vm.carouselEnhancedText,
        'text--marketing-banner': _vm.marketingBannerText,
        'text--no-inheritance': _vm.noInheritance,
        'text--inherit-weight': _vm.inheritWeight,
        'text--ellipsis': _vm.ellipsis,
    },attrs:{"part":_vm.$p('text', {
        'text--content': _vm.contentText,
        'text--offer': _vm.offerText,
        'text--promotion': _vm.promotionText,
        'text--landing': _vm.landingPageText,
        'text--carousel': _vm.carouselText,
        'text--carousel-enhanced': _vm.carouselEnhancedText,
        'text--marketing-banner': _vm.marketingBannerText,
        'text--no-inheritance': _vm.noInheritance,
        'text--inherit-weight': _vm.inheritWeight,
        'text--ellipsis': _vm.ellipsis,
    })}},'component',_vm.$filteredAttrs,false),[_vm._v("\n    "+_vm._s(_vm.unsafeContent)+"\n")]):_c(_vm.tag || 'div',_vm._b({tag:"component",staticClass:"text",class:{
        'text--content': _vm.contentText,
        'text--offer': _vm.offerText,
        'text--promotion': _vm.promotionText,
        'text--landing': _vm.landingPageText,
        'text--carousel': _vm.carouselText,
        'text--carousel-enhanced': _vm.carouselEnhancedText,
        'text--marketing-banner': _vm.marketingBannerText,
        'text--no-inheritance': _vm.noInheritance,
        'text--inherit-weight': _vm.inheritWeight,
        'text--ellipsis': _vm.ellipsis,
        'text--primary': _vm.primary,
    },attrs:{"part":_vm.$p('text', {
        'text--content': _vm.contentText,
        'text--offer': _vm.offerText,
        'text--promotion': _vm.promotionText,
        'text--landing': _vm.landingPageText,
        'text--carousel': _vm.carouselText,
        'text--carousel-enhanced': _vm.carouselEnhancedText,
        'text--marketing-banner': _vm.marketingBannerText,
        'text--no-inheritance': _vm.noInheritance,
        'text--inherit-weight': _vm.inheritWeight,
        'text--ellipsis': _vm.ellipsis,
        'text--primary': _vm.primary,
    })},domProps:{"innerHTML":_vm._s(_vm.processedText)}},'component',_vm.$filteredAttrs,false))};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-1cd30b77_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-1cd30b77";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
